export default __webpack_public_path__ + "static/media/icon_users.320fc643.svg";